// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SknSbLEyFFw45mD7PP7Q{box-shadow:0 1px 0 0 var(--border-neutral-default);justify-content:space-between;align-items:center;padding:24px 20px 20px 64px;display:flex}.SknSbLEyFFw45mD7PP7Q .Ry3PFtBK4zUHg3H1iiPe{padding:4px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `SknSbLEyFFw45mD7PP7Q`,
	"tabs": `Ry3PFtBK4zUHg3H1iiPe`
};
export default ___CSS_LOADER_EXPORT___;
